import React, { useState, createContext, useEffect } from 'react'

const AuthContext = createContext({})

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({})
  // const [auth, setAuth] = useState(() => {
  //   // initialize auth from sessionStorage if available
  //   const storedAuth = sessionStorage.getItem('auth') 
  //   return storedAuth ? JSON.parse(storedAuth) : {} 
  // })

  // // store auth state to sessionStorage
  // useEffect(() => {
  //   if (auth.accessToken) {
  //     sessionStorage.setItem('auth', JSON.stringify(auth))
  //   } else {
  //     sessionStorage.removeItem('auth')
  //   }
  // }, [auth])

  // listen for logout events from other tabs
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'logout_event') {
        // // clear auth state if another tab logged out
        // sessionStorage.removeItem('auth')
        setAuth({})
        // clear the logout event
        localStorage.removeItem('logout_event')
      }
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [])

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  )
}
export default AuthContext
